
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface NotificationScheduleInfoProps {
  sendHour: number;
  daysBeforeExpiration: number;
}

const NotificationScheduleInfo = ({ sendHour, daysBeforeExpiration }: NotificationScheduleInfoProps) => {
  // Valeurs par défaut pour éviter les erreurs
  const safeSendHour = sendHour ?? 8;
  const safeDaysBeforeExpiration = daysBeforeExpiration ?? 7;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Planification automatique</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Les notifications sont envoyées automatiquement chaque jour à {safeSendHour.toString().padStart(2, '0')}:00
            pour les produits qui expirent dans {safeDaysBeforeExpiration} jour(s).
          </p>
          <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-sm text-blue-800">
              <strong>Note:</strong> Le système vérifie automatiquement les produits et envoie les notifications
              selon la configuration définie ci-dessus.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NotificationScheduleInfo;
